<ng-container>

    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px; gap: 8px;" class="noPrint">
        <button mat-raised-button color="primary" (click)="printPage()">Print</button>
        <button mat-raised-button color="primary" (click)="exportExcel('Month_Wise_Business_Report')">Export</button>
        <button mat-dialog-close class="btn">Close</button>
    </div>

    <div class="container" id="print-section">
        <table class="table table-bordered"
            style="table-layout: auto; width: 100%; border-collapse: collapse; font-size: 12px;">

            <thead>

                <tr>
                    <th [attr.colspan]="7 + monthColumns.length" style="border: 2px solid black; padding: 6px 10px;">
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <span style="flex: 1; text-align: center; font-size: 15px; font-weight: bold; color: red;">
                                वर्गणी / अंक / पुस्तक विक्री विभाग – जमा व्यवसाय &nbsp;
                                {{ getMarathiDate(startDate) }} ते {{ getMarathiDate(endDate) }}
                            </span>
                            <span style="font-size: 13px; font-weight: bold; color: black; white-space: nowrap;">
                                दिनांक: {{ today | date:'dd/MM/yyyy' }}
                            </span>
                        </div>
                    </th>
                </tr>

                <!-- ROW 2: GROUP HEADERS -->
                <tr>
                    <th rowspan="3"
                        style="border: 2px solid black; text-align: center; vertical-align: middle; min-width: 35px;">
                        क्र.
                    </th>
                    <th rowspan="3"
                        style="border: 2px solid black; text-align: center; vertical-align: middle; min-width: 130px;">
                        कार्या. प्रतिनिधी नाव
                    </th>
                    <th rowspan="3"
                        style="border: 2px solid black; text-align: center; vertical-align: middle; min-width: 50px; font-size: 10px;">
                    </th>

                    <!-- वर्गणीदार -->
                    <th colspan="2" style="border: 2px solid black; text-align: center; font-weight: bold;">
                        वर्गणीदार
                    </th>

                    <!-- रक्कम -->
                    <th colspan="2" style="border: 2px solid black; text-align: center; font-weight: bold;">
                        रक्कम
                    </th>

                    <th *ngFor="let month of monthColumns" rowspan="3"
                        style="border: 2px solid black; text-align: center; vertical-align: middle; min-width: 65px;">
                        {{ month }}
                    </th>
                    <th rowspan="3" style="border: 2px solid black; text-align: center; min-width: 75px;
                   background-color: #e8f5e9; vertical-align: middle;">
                        एकूण
                    </th>
                </tr>

                <!-- ROW 3 -->
                <tr>
                    <th
                        style="border: 2px solid black; text-align: center; color: blue; font-weight: bold; min-width: 80px;">
                        एकूण जमा
                    </th>
                    <th rowspan="2"
                        style="border: 2px solid black; text-align: center; font-size: 10px; vertical-align: middle; min-width: 75px;">
                        उद्दीष्ट पूर्ण टक्के
                    </th>
                    <th
                        style="border: 2px solid black; text-align: center; color: blue; font-weight: bold; min-width: 90px;">
                        एकूण जमा
                    </th>
                    <th rowspan="2"
                        style="border: 2px solid black; text-align: center; font-size: 10px; vertical-align: middle; min-width: 75px;">
                        उद्दीष्ट पूर्ण टक्के
                    </th>
                </tr>

                <!-- ROW 4 -->
                <tr>
                    <th style="border: 2px solid black; text-align: center; color: red; font-size: 10px;">
                        दिलेले उद्दीष्ट
                    </th>
                    <th style="border: 2px solid black; text-align: center; color: red; font-size: 10px;">
                        दिलेले उद्दीष्ट
                    </th>
                </tr>

            </thead>

            <tbody>

                <!-- ====== OFFICE REP ROWS ====== -->
                <ng-container *ngFor="let row of officeRepRows; let i = index">

                    <!-- पूर्तता Row -->
                    <tr>
                        <td [attr.rowspan]="2"
                            style="border: 2px solid black; text-align: center; vertical-align: middle; font-weight: bold;">
                            {{ row.srNo }}
                        </td>
                        <td [attr.rowspan]="2" style="border: 2px solid black; text-align: left; vertical-align: middle;
                     font-weight: bold; padding-left: 5px;">
                            {{ row.office_rep_name }}
                        </td>
                        <td style="border: 1px solid black; text-align: center; font-size: 10px;
                       color: green; font-weight: bold; background-color: #f0fff0;">
                            पूर्तता
                        </td>

                        <!-- वर्गणीदार actual count -->
                        <td style="border: 1px solid black; text-align: right; color: blue; font-weight: bold;">
                            {{ row.totalSub }}
                        </td>
                        <!-- वर्गणीदार % -->
                        <td style="border: 1px solid black; text-align: right; font-size: 11px;">
                            {{ getPercentage(row.totalSub, row.target_sub) }}
                        </td>

                        <!-- रक्कम -->
                        <td style="border: 1px solid black; text-align: right; color: blue; font-weight: bold;">
                            {{ row.totalAmount | number:'1.0-0' }}
                        </td>
                        <!-- रक्कम % -->
                        <td style="border: 1px solid black; text-align: right; font-size: 11px;">
                            {{ getPercentage(row.totalAmount, row.target_amount) }}
                        </td>

                        <!-- Month columns -->
                        <td *ngFor="let key of monthKeys" style="border: 1px solid black; text-align: right;">
                            {{ row[key] ? (row[key] | number:'1.0-0') : '' }}
                        </td>

                        <!-- एकूण -->
                        <td style="border: 2px solid black; text-align: right; color: blue;
                       font-weight: bold; background-color: #e8f5e9;">
                            {{ row.totalAmount | number:'1.0-0' }}
                        </td>
                    </tr>

                    <!-- उद्दीष्ट Row -->
                    <tr style="background-color: #fff5f5;">
                        <td style="border: 1px solid black; text-align: center; font-size: 10px;
                       color: red; font-weight: bold; background-color: #fff0f0;">
                            उद्दीष्ट
                        </td>
                        <td style="border: 1px solid black; text-align: center; padding: 2px;">
                            <input type="number" [(ngModel)]="row.target_sub" (ngModelChange)="onTargetChange()"
                                (blur)="saveUdhistha(row)" style="width: 65px; border: 1px solid #f88; text-align: right;
  color: red; font-weight: bold; background: #fff8f8;" class="noPrint" />
                            <span class="printOnly" style="color: red; font-weight: bold;">{{ row.target_sub || 0
                                }}</span>
                        </td>
                        <td style="border: 1px solid black; background-color: #f9f9f9;"></td>
                        <td style="border: 1px solid black; text-align: center; padding: 2px;">
                            <input type="number" [(ngModel)]="row.target_amount" (ngModelChange)="onTargetChange()"
                                (blur)="saveUdhistha(row)" style="width: 80px; border: 1px solid #f88; text-align: right;
  color: red; font-weight: bold; background: #fff8f8;" class="noPrint" />
                            <span class="printOnly" style="color: red; font-weight: bold;">{{ row.target_amount || 0
                                }}</span>
                        </td>
                        <td style="border: 1px solid black; background-color: #f9f9f9;"></td>
                        <td *ngFor="let key of monthKeys" style="border: 1px solid black; background-color: #f9f9f9;">
                        </td>
                        <td style="border: 2px solid black; background-color: #f9f9f9;"></td>
                    </tr>

                </ng-container>

                <!-- ====== GRAND TOTAL — पूर्तता ====== -->
                <tr style="font-weight: bold; background-color: #d4edda;">
                    <td colspan="2" style="border: 2px solid black; text-align: center; font-size: 13px;">एकूण</td>
                    <td style="border: 2px solid black; text-align: center; font-size: 10px; color: green;">पूर्तता</td>
                    <td style="border: 2px solid black; text-align: right; color: blue; font-weight: bold;">
                        {{ grandTotalRow.totalSub }}
                    </td>
                    <td style="border: 2px solid black; text-align: right; font-size: 11px;">
                        {{ getPercentage(grandTotalRow.totalSub, grandTargetSub) }}
                    </td>
                    <td style="border: 2px solid black; text-align: right; color: blue; font-weight: bold;">
                        {{ grandTotalRow.totalAmount | number:'1.0-0' }}
                    </td>
                    <td style="border: 2px solid black; text-align: right; font-size: 11px;">
                        {{ getPercentage(grandTotalRow.totalAmount, grandTargetAmount) }}
                    </td>
                    <td *ngFor="let key of monthKeys"
                        style="border: 2px solid black; text-align: right; font-weight: bold;">
                        {{ getMonthTotal(key) ? (getMonthTotal(key) | number:'1.0-0') : '' }}
                    </td>
                    <td style="border: 2px solid black; text-align: right; color: blue;
                     font-weight: bold; background-color: #c8e6c9;">
                        {{ grandTotalRow.totalAmount | number:'1.0-0' }}
                    </td>
                </tr>

                <!-- ====== GRAND TOTAL — उद्दीष्ट ====== -->
                <tr style="font-weight: bold; background-color: #ffe0e0;">
                    <td colspan="2" style="border: 2px solid black; text-align: center; color: red;">उद्दीष्ट एकूण</td>
                    <td style="border: 2px solid black; text-align: center; font-size: 10px; color: red;">उद्दीष्ट</td>
                    <td style="border: 2px solid black; text-align: right; color: red; font-weight: bold;">{{
                        grandTargetSub }}</td>
                    <td style="border: 2px solid black;"></td>
                    <td style="border: 2px solid black; text-align: right; color: red; font-weight: bold;">
                        {{ grandTargetAmount | number:'1.0-0' }}
                    </td>
                    <td style="border: 2px solid black;"></td>
                    <td *ngFor="let key of monthKeys" style="border: 2px solid black;"></td>
                    <td style="border: 2px solid black;"></td>
                </tr>

                <!-- ====== मागील वर्षीचा व्यवसाय ====== -->
                <tr style="background-color: #fff3e0;">
                    <td colspan="7" style="border: 2px solid black; text-align: left; font-weight: bold;
           color: #e65100; font-size: 12px; padding-left: 6px;">
                        मागील वर्षीचा व्यवसाय - {{ getPreviousYearLabel() }}
                    </td>

                    <td *ngFor="let key of monthKeys"
                        style="border: 2px solid black; text-align: right; font-weight: bold; color: #e65100;">
                        {{ lastYearMonthData[key] ? (lastYearMonthData[key] | number:'1.0-0') : '' }}
                    </td>

                    <td style="border: 2px solid black; text-align: right; font-weight: bold;
             color: #e65100; background-color: #ffe0b2;">
                        {{ getLastYearMonthTotal() | number:'1.0-0' }}
                    </td>
                </tr>

                <!-- ====== फरक ====== -->
                <tr style="background-color: #e8f5e9;">
                    <td colspan="7" style="border: 2px solid black; text-align: left; font-weight: bold;
                   color: #1b5e20; font-size: 12px; padding-left: 6px;">
                        फरक (चालू - मागील)
                    </td>

                    <td *ngFor="let key of monthKeys"
                        style="border: 2px solid black; text-align: right; font-weight: bold;"
                        [style.color]="getDifferenceForMonth(key) >= 0 ? '#1b5e20' : '#b71c1c'">
                        {{ getDifferenceForMonth(key) !== 0 ? (getDifferenceForMonth(key) | number:'1.0-0') : '' }}
                    </td>
                    <td style="border: 2px solid black; text-align: right; font-weight: bold; background-color: #c8e6c9;"
                        [style.color]="getDifferenceTotal() >= 0 ? '#1b5e20' : '#b71c1c'">
                        {{ getDifferenceTotal() | number:'1.0-0' }}
                    </td>
                </tr>
                <!-- ====== चालू वर्षाचे वर्गणीदार ====== -->
                <tr>
                    <td colspan="7"
                        style="border: 2px solid black; font-weight: bold; padding: 4px 14px; white-space: nowrap;">
                        चालू वर्षाचे वर्गणीदार &nbsp;{{ getCurrentYearFullLabel() }}
                    </td>
                    <td *ngFor="let key of monthKeys"
                        style="border: 2px solid black; text-align: right; padding: 4px 8px;">
                        {{ grandTotalRow[key + '_cnt'] || '' }}
                    </td>
                    <td
                        style="border: 2px solid black; text-align: right; padding: 4px 10px; font-weight: bold; background-color: #e8f5e9;">
                        {{ grandTotalRow.totalSub }}
                    </td>
                </tr>

                <!-- ====== मागील वर्षाचे वर्गणीदार ====== -->
                <tr>
                    <td colspan="7"
                        style="border: 2px solid black; font-weight: bold; padding: 4px 14px; white-space: nowrap;">
                        मागील वर्षाचे वर्गणीदार &nbsp;{{ getPreviousYearFullLabel() }}
                    </td>
                    <td *ngFor="let key of monthKeys"
                        style="border: 2px solid black; text-align: right; padding: 4px 8px;">
                        {{ lastYearMonthSubCount[key] || '' }}
                    </td>
                    <td
                        style="border: 2px solid black; text-align: right; padding: 4px 10px; font-weight: bold; background-color: #fff3e0;">
                        {{ getLastYearTotalSubCount() }}
                    </td>
                </tr>

                <!-- ====== फरक ( मागील - चालू ) ====== -->
                <tr style="background-color: #f5f5f5;">
                    <td colspan="7"
                        style="border: 2px solid black; font-weight: bold; padding: 4px 14px; white-space: nowrap;">
                        फरक ( मागील - चालू )
                    </td>
                    <td *ngFor="let key of monthKeys"
                        style="border: 2px solid black; text-align: right; padding: 4px 8px; font-weight: bold;"
                        [style.color]="getDifferenceSubCountForMonth(key) >= 0 ? '#1b5e20' : '#b71c1c'">
                        {{ getDifferenceSubCountForMonth(key) !== 0 ? getDifferenceSubCountForMonth(key) : '' }}
                    </td>
                    <td style="border: 2px solid black; text-align: right; padding: 4px 10px; font-weight: bold; background-color: #eeeeee;"
                        [style.color]="(getLastYearTotalSubCount() - grandTotalRow.totalSub) >= 0 ? '#1b5e20' : '#b71c1c'">
                        {{ grandTotalRow.totalSub - getLastYearTotalSubCount() }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</ng-container>

<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>